/**
 * Created by Mattias on 2014-10-09.
 */
define('payment/handlers/sendHandlers/sendHandlerController',['jquery', 'payment/handlers/sendHandlers/resultAfterSingleCallHandler', 'payment/handlers/sendHandlers/externalPanelHandler',
        'payment/handlers/sendHandlers/internalPanelHandler', 'payment/handlers/sendHandlers/asynchronousResultAfterSingleCallHandler',
        'payment/handlers/sendHandlers/pendingAfterSingleCallHandler'],

    function($, resultAfterSingleCallHandler, externalPanelHandler, internalPanelHandler, asynchronousResultAfterSingleCallHandler, pendingAfterSingleCallHandler) {
        'use strict';

        var sendHandlers = {
            RESULT_AFTER_SINGLE_CALL : resultAfterSingleCallHandler,
            EXTERNAL_PANEL : externalPanelHandler,
            INTERNAL_PANEL : internalPanelHandler,
            ASYNCHRONOUS_RESULT_AFTER_SINGLE_CALL: asynchronousResultAfterSingleCallHandler,
            PENDING_RESULT_AFTER_SINGLE_CALL: pendingAfterSingleCallHandler
        };

		function init(methodNameIn) {
		}

        function handleSuccessfulResponse(paymentBox, sendHandlerData, accHistRef, paymentFetchResultFlow) {

			// This condition seems to be needed for withdraws
			var sendHandlerControllerData = (sendHandlerData.actualSendHandler !== undefined ? sendHandlerData : sendHandlerData.handler);

            if (typeof(sendHandlerControllerData.providerResultTextValue) !== 'undefined' && typeof(paymentBox) !== 'undefined') {
                paymentBox.$controller.trigger('provider-result', { text: sendHandlerControllerData.providerResultTextValue});
            }

            var actualSendHandlerData = typeof(sendHandlerControllerData.sendHandlerData) !== 'undefined' ? sendHandlerControllerData.sendHandlerData : sendHandlerData;

            var actualSendHandler = sendHandlers[sendHandlerControllerData.actualSendHandler];
            actualSendHandler.handleSuccessfulResponse(paymentBox, actualSendHandlerData, accHistRef, paymentFetchResultFlow);
        }

        function cleanupOnFail() {}

        var sendHandlerController = {};
        sendHandlerController.init = init;
        sendHandlerController.handleSuccessfulResponse = handleSuccessfulResponse;
        sendHandlerController.cleanupOnFail = cleanupOnFail;

        return sendHandlerController;
    }
);

